import React from "react";

/* eslint-disable max-len */
export default function ReactionCountIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 29.6 27.4" enableBackground="new 0 0 29.6 27.4" xmlSpace="preserve">
		<path fill="#AAAAAA" d="M14.8,26.7l-2.1-1.9C5.4,18.2,0.6,13.9,0.6,8.5c0-4.4,3.4-7.8,7.8-7.8c2.5,0,4.8,1.1,6.4,3
			c1.5-1.8,3.9-3,6.4-3c4.4,0,7.8,3.4,7.8,7.8c0,5.4-4.8,9.7-12.1,16.4L14.8,26.7z"/>
		</svg>
    );
}
